module.exports = __webpack_public_path__ + "b15d0770cd20a9683a0806e3c7e73b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/mask.png
// module id = 282
// module chunks = 0